import "./Breadcrumb.css";
import * as React from "react";
import classnames from "classnames";
export var Breadcrumb = function (_a) {
    var className = _a.className, originalTopNode = _a.originalTopNode, selectedNodeId = _a.selectedNodeId, zoomTo = _a.zoomTo, namePropInData = _a.namePropInData;
    var selectedNodeFromOriginalTree = originalTopNode
        .descendants()
        .filter(function (n) {
        return n.data.id === selectedNodeId;
    })
        .pop();
    var items = originalTopNode
        .path(selectedNodeFromOriginalTree)
        .map(function (_a) {
        var data = _a.data;
        return {
            text: data[namePropInData],
            key: data.id,
            onClick: data.id !== selectedNodeId ? function () { return zoomTo(data.id); } : undefined,
        };
    });
    var itemsFinal = items && items.length
        ? items
        : [{ text: originalTopNode.data[namePropInData], key: 0 }];
    return (React.createElement("div", { className: classnames("TreeMap__breadcrumb", className) }, itemsFinal.map(function (item, index) { return (React.createElement("div", { key: index },
        React.createElement("a", { className: "TreeMap__breadcrumbItem", key: item.key, id: "".concat(item.key), onClick: item.onClick ? item.onClick : undefined, style: { cursor: item.onClick ? "pointer" : "auto" } }, item.text),
        index < itemsFinal.length - 1 ? (React.createElement("span", { className: "TreeMap__breadcrumbSeparator" }, "/")) : null)); })));
};
